import React from 'react'
import Link from 'next/link'
import { Nav } from 'reactstrap'

export function BottomNav (props) {
  return (
    <div className='bottom-navigation bg-dark fixed-bottom d-lg-none' role='navigation'>
      <Nav tag='nav'>
        <Link href='/'>
          <a className='nav-link'>
            <svg className='icon'>
              <use xlinkHref='#home' href='#home'></use>
            </svg>
            <div>Home</div>
          </a>
        </Link>
        <Link href='/import'>
          <a className='nav-link'>
            <svg className='icon'>
              <use xlinkHref='#import' href='#import'></use>
            </svg>
            <div>Import</div>
          </a>
        </Link>
        <Link href='/help'>
          <a className='nav-link'>
            <svg className='icon'>
              <use xlinkHref='#help' href='#help'></use>
            </svg>
            <div>Help</div>
          </a>
        </Link>
        <Link href='/logout'>
          <a className='nav-link'>
            <svg className='icon'>
              <use xlinkHref='#logout_rounded' href='#logout_rounded'></use>
            </svg>
            <div>Logout</div>
          </a>
        </Link>
      </Nav>
    </div>
  )
}
